import React from 'react'
import PropTypes from 'prop-types'
import './index.scss'
import timeImg from '../../../assets/image/time@2x.png'
import likeImg from '../../../assets/image/dianzan@2x.png'
import likedImg from '../../../assets/image/dianzand.png'
import commemtImg from '../../../assets/image/comment@2x.png'
import CommentSecondItem from '../../CommentSecondItem'
import defaultHead from '../../../assets/image/ic_default_avatar.png';
import LazyLoadImg from '../LazyLoadImg';
import utils from 'bxl-utils';

const secondCommentsList = (commentItem, clickToComment, type, toSecondComment, parentIndex) => {
  if (type !== 'secondPageList' && commentItem.descendants) {
    commentItem.descendants.splice(2)
  }
  if (commentItem.descendants && commentItem.descendants.length > 0) {
    return (
      <div className='secondCommentsBox'>
        {
          commentItem.descendants.map((item2, index2) => {
            return (
              <CommentSecondItem
                toSecondComment={toSecondComment}
                type={type}
                key={'CommentSecondItem' + index2}
                clickToComment={clickToComment}
                index2={index2} 
                descendants={item2}
                descendantsNum={+commentItem.root.comment.descendantsN}
                parentIndex={parentIndex}
              ></CommentSecondItem>
            )
          })
        }
      </div>
    )
  }
  return null
}

const CommentMainItem = (props) => {
  const { commentItem, clickToComment, index, likeComment, toSecondComment, type } = props
  const MainComment = commentItem?.root?.comment
  if (!MainComment) return null
  const secondComment = () => {
    toSecondComment(commentItem.root.comment.id)
  }
  return (
    <div className='commentItem' data-type={commentItem.root.comment.id} data-pid='commentItem' data-index={index}>
      <div className='commentHeader'
        onClick={clickToComment.bind(this, { commentId: MainComment.id, name: MainComment.userLabel, index })}>
        <div className='commentHeadImgBox'>
          <LazyLoadImg image={(MainComment.userAvatar || defaultHead)} alt={MainComment.userLabel || 'user comment avatar'} className='commentHeadImg'></LazyLoadImg>
        </div>
        <div className='userName'>{MainComment.userLabel}</div>
      </div>
      <div className='commentInfo'
        onClick={clickToComment.bind(this, { commentId: MainComment.id, name: MainComment.userLabel, index })}>
        {MainComment.content}
      </div>
      <div className='commentFooter'>
        <div className='commentTime'>
          <img className='timeIcon' src={timeImg} alt="time icon" />
          <span className='time'>{utils?.formatter?.format(+MainComment.postedAt, 'MM-DD HH:mm')}</span>
        </div>
        {
          type !== 'secondPageList' ? (
            <div className='commentOperation'>
              <div className='commentOperationItem' onClick={toSecondComment.bind(this, MainComment.id)}>
                <img className='commentIcon' src={commemtImg} alt="comment icon" />
                <span className='commentItemNum'>{MainComment.descendantsN}</span>
              </div>
              <div className='commentOperationItem' onClick={likeComment.bind(this, { index: index })}>
                <img className='likeIcon' src={commentItem.root.liked ? likedImg : likeImg} alt="like icon" />
                <span className='likeNum'>{MainComment.likes > 0 ? MainComment.likes : '赞'}</span>
              </div>
            </div>
          ) : null
        }
      </div>
      {
        secondCommentsList(commentItem, clickToComment, type, secondComment, index)
      }
    </div>
  )
}

CommentMainItem.propTypes = {
  commentItem: PropTypes.object,
  clickToComment: PropTypes.func,
  toSecondComment: PropTypes.func
}

export default CommentMainItem